import React from "react";

function Person(props) {
  function handleClick(event) {
    const { id } = event.target;
    props.setTime(id);
  }

  return (
    <div className="parent-person">
      <div className="child-person">
        <div className="container-person">
          <img src={props.img} alt={props.nameOfPerson} />
          <div className="title">
            <p>Report For</p>
            <h1 className="big-text">{props.nameOfPerson}</h1>
          </div>
        </div>
      </div>
      <fieldset className="selectors">
        <legend className="sr-only">Select the timeframe to use for number of hours of each Activity.</legend>
        <input
          type="radio"
          name="timeframe"
          value="daily"
          id="daily"
          onClick={handleClick}
        />
          <label htmlFor="daily" className={props.time === "daily" ? "selector active" : "selector"}>Daily</label>
        <input
          type="radio"
          name="timeframe"
          value="weekly"
          id="weekly"
          onClick={handleClick}
        />
          <label htmlFor="weekly" className={props.time === "weekly" ? "selector active" : "selector"}>Weekly</label>
        <input
          type="radio"
          name="timeframe"
          value="monthly"
          id="monthly"
          onClick={handleClick}
        />
        <label htmlFor="monthly" className={props.time === "monthly" ? "selector active" : "selector"}>Monthly</label>
      </fieldset>
    </div>
  );
}

export default Person;
